// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tech-cards-section {
  margin: 4rem 0;
  padding: 0 2rem;
}

.tech-cards-header {
  text-align: center;
  margin-bottom: 3rem;
}

.tech-cards-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  background: linear-gradient(135deg, #8B4513 0%, #D2B48C 50%, #F5DEB3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.tech-cards-subtitle {
  font-size: 1.1rem;
  color: #495057;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.tech-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.tech-card {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
}

.tech-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--tech-color);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.tech-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.tech-card:hover::before {
  transform: scaleX(1);
}

.tech-card-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.tech-logo {
  font-size: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  border-radius: 12px;
  border: 2px solid #e5e7eb;
  transition: all 0.3s ease;
}

.tech-card:hover .tech-logo {
  background: linear-gradient(135deg, var(--tech-color)20 0%, var(--tech-color)10 100%);
  border-color: var(--tech-color);
  transform: scale(1.1);
}

.tech-name {
  font-size: 1.5rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0;
}

.tech-description {
  color: #495057;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-size: 0.95rem;
}

.tech-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.tech-color-indicator {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Dark theme support */
[data-theme="dark"] .tech-cards-title {
  background: linear-gradient(135deg, #D2B48C 0%, #F5DEB3 50%, #FFF8DC 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

[data-theme="dark"] .tech-cards-subtitle {
  color: #ecf0f1;
}

[data-theme="dark"] .tech-card {
  background: rgba(44, 62, 80, 0.9);
  border-color: rgba(255, 255, 255, 0.1);
  color: #ecf0f1;
}

[data-theme="dark"] .tech-card:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.1);
}

[data-theme="dark"] .tech-name {
  color: #ecf0f1;
}

[data-theme="dark"] .tech-description {
  color: #bdc3c7;
}

[data-theme="dark"] .tech-logo {
  background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);
  border-color: #34495e;
}

[data-theme="dark"] .tech-card:hover .tech-logo {
  background: linear-gradient(135deg, var(--tech-color)20 0%, var(--tech-color)10 100%);
}

/* Responsive design */
@media (max-width: 768px) {
  .tech-cards-section {
    padding: 0 1rem;
    margin: 3rem 0;
  }
  
  .tech-cards-title {
    font-size: 2rem;
  }
  
  .tech-cards-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
  
  .tech-card {
    padding: 1.5rem;
  }
  
  .tech-logo {
    width: 50px;
    height: 50px;
    font-size: 2rem;
  }
  
  .tech-name {
    font-size: 1.25rem;
  }
}

@media (max-width: 480px) {
  .tech-cards-title {
    font-size: 1.75rem;
  }
  
  .tech-cards-subtitle {
    font-size: 1rem;
  }
  
  .tech-card {
    padding: 1.25rem;
  }
  
  .tech-card-header {
    gap: 0.75rem;
  }
  
  .tech-logo {
    width: 45px;
    height: 45px;
    font-size: 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TechCards/TechCards.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,iFAAiF;EACjF,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,6BAA6B;EAC7B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,qFAAqF;AACvF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,qFAAqF;EACrF,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,uBAAuB;AACvB;EACE,0EAA0E;EAC1E,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,qFAAqF;AACvF;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF","sourcesContent":[".tech-cards-section {\n  margin: 4rem 0;\n  padding: 0 2rem;\n}\n\n.tech-cards-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.tech-cards-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1rem;\n  background: linear-gradient(135deg, #8B4513 0%, #D2B48C 50%, #F5DEB3 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.tech-cards-subtitle {\n  font-size: 1.1rem;\n  color: #495057;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.tech-cards-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.tech-card {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  -webkit-backdrop-filter: blur(10px);\n  backdrop-filter: blur(10px);\n}\n\n.tech-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--tech-color);\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.tech-card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.tech-card:hover::before {\n  transform: scaleX(1);\n}\n\n.tech-card-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.tech-logo {\n  font-size: 2.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  border-radius: 12px;\n  border: 2px solid #e5e7eb;\n  transition: all 0.3s ease;\n}\n\n.tech-card:hover .tech-logo {\n  background: linear-gradient(135deg, var(--tech-color)20 0%, var(--tech-color)10 100%);\n  border-color: var(--tech-color);\n  transform: scale(1.1);\n}\n\n.tech-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #2c3e50;\n  margin: 0;\n}\n\n.tech-description {\n  color: #495057;\n  line-height: 1.6;\n  margin-bottom: 1.5rem;\n  font-size: 0.95rem;\n}\n\n.tech-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.tech-color-indicator {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Dark theme support */\n[data-theme=\"dark\"] .tech-cards-title {\n  background: linear-gradient(135deg, #D2B48C 0%, #F5DEB3 50%, #FFF8DC 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n[data-theme=\"dark\"] .tech-cards-subtitle {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .tech-card {\n  background: rgba(44, 62, 80, 0.9);\n  border-color: rgba(255, 255, 255, 0.1);\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .tech-card:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.3), 0 10px 10px -5px rgba(0, 0, 0, 0.1);\n}\n\n[data-theme=\"dark\"] .tech-name {\n  color: #ecf0f1;\n}\n\n[data-theme=\"dark\"] .tech-description {\n  color: #bdc3c7;\n}\n\n[data-theme=\"dark\"] .tech-logo {\n  background: linear-gradient(135deg, #34495e 0%, #2c3e50 100%);\n  border-color: #34495e;\n}\n\n[data-theme=\"dark\"] .tech-card:hover .tech-logo {\n  background: linear-gradient(135deg, var(--tech-color)20 0%, var(--tech-color)10 100%);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .tech-cards-section {\n    padding: 0 1rem;\n    margin: 3rem 0;\n  }\n  \n  .tech-cards-title {\n    font-size: 2rem;\n  }\n  \n  .tech-cards-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n  \n  .tech-card {\n    padding: 1.5rem;\n  }\n  \n  .tech-logo {\n    width: 50px;\n    height: 50px;\n    font-size: 2rem;\n  }\n  \n  .tech-name {\n    font-size: 1.25rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .tech-cards-title {\n    font-size: 1.75rem;\n  }\n  \n  .tech-cards-subtitle {\n    font-size: 1rem;\n  }\n  \n  .tech-card {\n    padding: 1.25rem;\n  }\n  \n  .tech-card-header {\n    gap: 0.75rem;\n  }\n  \n  .tech-logo {\n    width: 45px;\n    height: 45px;\n    font-size: 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
